import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowDown, ArrowUpRight, Check, Instagram, Menu, X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wyeeJtwvu1HiXsJKfGXny6/1.png';
const ICE_IMAGE = 'https://cdn.magicpatterns.com/uploads/knKE32EsZkYsqPa1ui7YrB/DSC03885.jpg';
const SOCIAL_IMAGE = 'https://cdn.magicpatterns.com/uploads/m4VHGC1GgxgtGcoFZGpH81/IMG_0693.jpg';
const CAN_IMAGE = 'https://cdn.magicpatterns.com/uploads/wDu3fKhK1RBeGFe1tY72ry/DSC03888.jpg';
const VIDEO_MOMENT = 'https://cdn.magicpatterns.com/uploads/macVvEoEwdpGBSYDC8PDiv/CPSTHLM_30.mp4';
const PEOPLE_IMAGE_1 = 'https://cdn.magicpatterns.com/uploads/1KzvTsy3KfZ88WPDkaVLMn/WAGHORN_2026-03-22_18.jpg';
const PEOPLE_IMAGE_2 = 'https://cdn.magicpatterns.com/uploads/oLZUyGYJTdHH83PscaSwsS/IMG_0700.jpg';
const ICE_BOWL_IMAGE = 'https://cdn.magicpatterns.com/uploads/p4Sk3dNMD8P9BQwDabDdK8/DSC04025.jpg';
const SILVER_HEART = 'https://cdn.magicpatterns.com/uploads/rJT9byhsXeU9KaTKr1LjUf/1.png';
const BEET_RED = 'https://cdn.magicpatterns.com/uploads/qULQc3HvRqojPLg7YXAYH5/Rodbeta.png';
const BEET_YELLOW = 'https://cdn.magicpatterns.com/uploads/3uGPvVV79oZz5PUQ2CQhbW/gulbeta.png';
const BEET_WHITE = 'https://cdn.magicpatterns.com/uploads/4xdunyqX2XsEhDvajcVBUY/VITBETA.png';
const CAN_LINEUP_IMAGE = 'https://cdn.magicpatterns.com/uploads/4nRxNXZRgXs6U5T42kX5ab/Burk_1.png';
const INSTAGRAM_URL = 'https://www.instagram.com/beatyourbest_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==';
const CONTACT_EMAIL = 'info@beatsoda.com';
const WEB3FORMS_KEY = 'a23b9419-6869-4092-bd1e-0a48a2461c5e';
const EASE = [0.23, 1, 0.32, 1] as const;
const rise = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: EASE
    }
  }
};
const stagger = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05
    }
  }
};
const WORLD_WORDS = ['Music', 'Food', 'Friends', 'Travel', 'Sport', 'Nightlife'];
const NAV_LINKS = [{
  label: 'The Drink',
  id: 'product'
}, {
  label: 'Flavours',
  id: 'flavours'
}, {
  label: 'World',
  id: 'world'
}, {
  label: 'People',
  id: 'people'
}, {
  label: 'Story',
  id: 'story'
}, {
  label: 'Join',
  id: 'join'
}];
const COMING_SOON = [{
  name: 'Yellow BEAT',
  symbol: BEET_YELLOW
}, {
  name: 'White BEAT',
  symbol: BEET_WHITE
}];
const INGREDIENTS = ['Beetroot', 'Grapefruit', 'Pomegranate', 'Lemon', 'Elderflower', 'Apple Juice Concentrate', 'Apple Cider Vinegar'];
export function LandingPage() {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="w-full bg-beat-black font-sans text-white antialiased" data-id="element-1" data-mp="tzzql4t3kpts">
      <SiteHeader onNavigate={scrollTo} data-id="element-2" data-mp="2bw1ujzg2sn26" />

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="relative min-h-screen w-full overflow-hidden" data-id="element-3" data-mp="2guwkdlcgnbvs">
        <motion.img src={ICE_IMAGE} alt="A cold BEAT can buried in crushed ice" initial={{
        opacity: 0,
        scale: 1.06
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: EASE
      }} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-4" data-mp="2lmo2r8lgqbau" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(to top, rgba(10,10,10,0.88) 0%, rgba(10,10,10,0.45) 45%, rgba(10,10,10,0.12) 75%, rgba(255,255,255,0.35) 100%)'
      }} data-id="element-5" data-mp="21xm0bnlr4xog" />

        <motion.div initial="hidden" animate="visible" variants={stagger} className="relative z-10 flex min-h-screen flex-col justify-end px-5 pb-20 pt-40 md:px-10 md:pb-24" data-id="element-6" data-mp="3icdv276deh0x">
          <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-white/70 uppercase" data-id="element-7" data-mp="3byhq7d50eajn">
            Good taste · Good people · Good times
          </motion.p>

          <motion.h1 variants={rise} className="max-w-[18ch] text-5xl font-medium leading-[1.1] tracking-tight md:text-7xl lg:text-8xl" data-id="element-8" data-mp="3lx7cdi3xuh5p">
            A better way to experience <span className="text-beat-red" data-id="element-9" data-mp="3utomqj4hab0e">life.</span>
          </motion.h1>

          <motion.div variants={rise} className="mt-10 flex flex-col gap-6 sm:flex-row sm:items-center" data-id="element-10" data-mp="dernx2it0o5w">
            <button onClick={() => scrollTo('product')} className="group inline-flex items-center gap-3 rounded-full bg-beat-red px-8 py-4 text-base font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black" style={{
            transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
          }} data-id="element-11" data-mp="mfza4m81pyjm">
              Discover BEAT
              <ArrowUpRight size={18} className="transition-transform duration-150 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-12" data-mp="s2ro2vb7fsz6" />
            </button>
            <p className="max-w-xs text-base text-white/60" data-id="element-13" data-mp="ib5fz7u5ya0n">
              A Real Root & Fruit Soda 
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.6,
        duration: 0.6
      }} className="absolute bottom-8 right-5 z-10 text-white/50 md:right-10" data-id="element-14" data-mp="8e0t15shuais">
          <ArrowDown size={22} className="animate-bounce" data-id="element-15" data-mp="4c5oztj6hj1b" />
        </motion.div>
      </section>

      {/* ── 02: THIS IS BEAT (PRODUCT) ───────────────────────── */}
      <section id="product" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-16" data-mp="263o3b0j3n1g7">
        <div className="mx-auto grid max-w-[1200px] items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-17" data-mp="2191nml5zimqb">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} data-id="element-18" data-mp="1w9fascu2j8i1">
            <motion.p variants={rise} className="mb-8 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-19" data-mp="2k0uiym8j0k17">
              The Drink
            </motion.p>
            <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-20" data-mp="2b17gdx42986k">
              This is BEAT.
            </motion.h2>
            <motion.p variants={rise} className="mt-8 max-w-md text-xl leading-relaxed text-white/70" data-id="element-21" data-mp="zkzlmhuvf15g">
              A drink for the moments worth remembering. Bright, bold, rewarding, and balanced.
            </motion.p>

            <motion.button variants={rise} onClick={() => scrollTo('flavours')} className="mt-10 inline-flex items-center gap-2 text-base font-medium text-beat-red transition-colors hover:text-white" data-id="element-22" data-mp="3g5uw6nnz9i1g">
              Discover the flavours <ArrowDown size={18} data-id="element-23" data-mp="3tyu86fojwu49" />
            </motion.button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.8,
          ease: EASE
        }} className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl" data-id="element-24" data-mp="2rrhrqgjerv3">
            <img src={CAN_IMAGE} alt="A BEAT can resting on a railing" className="h-full w-full object-cover" data-id="element-25" data-mp="1uo2713vyyq43" />
          </motion.div>
        </div>
      </section>

      {/* ── 02B: THE FLAVOURS ────────────────────────────────── */}
      <section id="flavours" className="scroll-mt-20 rounded-t-[3rem] bg-[#F5F3EF] px-5 py-20 text-beat-black md:px-10 md:py-28" data-id="element-26" data-mp="1zf25idkqlg8p">
        <div className="mx-auto max-w-[1200px]" data-id="element-27" data-mp="1bq9dutb5dujw">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-10 md:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] md:items-end" data-id="element-28" data-mp="16rg5ffapwtql">
            <div data-id="element-29" data-mp="2w4jjdftvi8lh">
              <motion.p variants={rise} className="mb-6 text-sm font-medium uppercase tracking-widest text-beat-red" data-id="element-30" data-mp="2w4009vshle5v">
                The Flavours
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium leading-[1.05] tracking-tight md:text-6xl" data-id="element-31" data-mp="2zq4ubw1h9wdw">
                Meet BEAT.
              </motion.h2>
              <motion.div variants={rise} className="mt-8 h-px w-16 bg-beat-red" data-id="element-32" data-mp="2uonrhuzfnzuo" />
            </div>
            <motion.p variants={rise} className="max-w-md text-xl leading-relaxed text-black/60" data-id="element-33" data-mp="3ifkvmlkzlsvd">
              Bold. Refreshing. Made from real ingredients. For real moments. We
              start with one — the red beet.
            </motion.p>
          </motion.div>

          {/* Red BEAT — available now */}
          <motion.article initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="mt-16" data-id="element-34" data-mp="57zyop17rs1w">
            <motion.div variants={rise} className="py-4 md:py-8" data-id="element-35" data-mp="2d4b72j7lkk7m">
              <img src={CAN_LINEUP_IMAGE} alt="Red BEAT can shown from three sides, with beetroot artwork, ingredients and nutrition" className="mx-auto w-full max-w-4xl mix-blend-darken" data-id="element-36" data-mp="2i2us8hed9ryx" />
            </motion.div>
            <motion.div variants={rise} className="grid gap-10 border-t border-black/10 pt-10 md:grid-cols-2 md:pt-14" data-id="element-37" data-mp="1udaa20q1eyqp">
              <div data-id="element-38" data-mp="1z51urumiia8x">
                <div className="flex items-center gap-3" data-id="element-39" data-mp="1lcc4vf3v4l6j">
                  <span className="h-3 w-3 rounded-full bg-beat-red" data-id="element-40" data-mp="1ldwzt5u3a64x" />
                  <span className="text-sm font-medium uppercase tracking-widest text-beat-red" data-id="element-41" data-mp="1pd5tkap4q40h">
                    Available now
                  </span>
                </div>
                <div className="mt-5 flex items-center gap-5" data-id="element-42" data-mp="1gczj6xoq9k5j">
                  <img src={BEET_RED} alt="" aria-hidden="true" className="h-24 w-auto flex-shrink-0 mix-blend-darken md:h-32" data-id="element-43" data-mp="1gchb93spdhhs" />
                  <h3 className="text-3xl font-medium tracking-tight md:text-5xl" data-id="element-44" data-mp="16pn8hm4wqo4d">
                    Red BEAT
                  </h3>
                </div>
                <p className="mt-5 max-w-md text-lg leading-relaxed text-black/60" data-id="element-45" data-mp="11oz5s37bgiub">
                  Beetroot meets grapefruit, pomegranate and citrus in a vibrant
                  blend with floral notes and a crisp finish.
                </p>
              </div>
              <div className="flex flex-col justify-center gap-6 md:border-l md:border-black/10 md:pl-14" data-id="element-46" data-mp="1pgo6o7y7efmv">
                <div className="flex flex-wrap gap-x-6 gap-y-3 text-base text-black/70" data-id="element-47" data-mp="1kgrz5yqas62k">
                  {INGREDIENTS.map(item => <span key={item} data-id="element-48" data-mp="1yh2qf2virmo9">{item}</span>)}
                </div>
                <p className="border-t border-black/10 pt-6 text-base text-black/50" data-id="element-49" data-mp="1ugsj9mvzqq7t">
                  250 ml · No added sugar · Low calorie · Caffeine free ·
                  Alcohol free
                </p>
              </div>
            </motion.div>
          </motion.article>

          {/* Yellow + White — coming soon */}
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="mt-6 grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-50" data-mp="2ber53w3eyniv">
            {COMING_SOON.map(flavour => <motion.article key={flavour.name} variants={rise} className="flex items-center gap-6 rounded-3xl border border-black/10 p-8" data-id="element-51" data-mp="2u6tohf7fwhwt">
                <img src={flavour.symbol} alt="" aria-hidden="true" className="h-24 w-auto flex-shrink-0 opacity-60 mix-blend-darken" data-id="element-52" data-mp="zu3smrxigyms" />
                <div data-id="element-53" data-mp="3i3zmg1xbujsg">
                  <h3 className="text-xl font-medium tracking-tight text-black/70 md:text-2xl" data-id="element-54" data-mp="3i4j3zhj2f65y">
                    {flavour.name}
                  </h3>
                  <p className="mt-1 text-base text-black/45" data-id="element-55" data-mp="39b64txuer8bf">Coming soon</p>
                </div>
              </motion.article>)}
          </motion.div>

          <motion.p initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={rise} className="mt-12 text-base text-black/50" data-id="element-56" data-mp="4vmuavnvcn98">
            No alcohol. No caffeine. Nothing artificial.
          </motion.p>
        </div>
      </section>

      {/* ── MARQUEE ──────────────────────────────────────────── */}
      <Marquee data-id="element-57" data-mp="2glphhelnahm2" />

      {/* ── 03: THE WORLD ────────────────────────────────────── */}
      <section id="world" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-58" data-mp="2bmmdlxheihfo">
        <div className="mx-auto max-w-[1200px]" data-id="element-59" data-mp="3d4oplj8dmlf">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] lg:gap-16" data-id="element-60" data-mp="3cd6dcen9ld3">
            <div data-id="element-61" data-mp="3vf2vtz4oih4v">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-62" data-mp="n1x0dgq2op12">
                The World
              </motion.p>
              <motion.p variants={rise} className="text-3xl font-medium leading-snug text-white md:text-4xl" data-id="element-63" data-mp="d494gngqdbhb">
                BEAT lives where good people, good taste and good experiences
                meet.
              </motion.p>
              <motion.p variants={rise} className="mt-6 max-w-sm text-lg leading-relaxed text-white/60" data-id="element-64" data-mp="32si6t5boeh4h">
                A dinner. A festival. A studio. A beach. A basement bar at 1am.
                The place changes. The feeling doesn't.
              </motion.p>
            </div>

            <motion.div variants={rise} data-id="element-65" data-mp="348w0017mxua2">
              <ul className="flex flex-wrap items-baseline gap-x-6 gap-y-2" data-id="element-66" data-mp="347ujvibrihlh">
                {WORLD_WORDS.map(word => <li key={word} className="text-4xl font-medium tracking-tight text-white/85 md:text-5xl lg:text-6xl" data-id="element-67" data-mp="2bl03awi2g2da">
                    {word}
                    <span className="text-beat-red" data-id="element-68" data-mp="2lbmf0fmnw8qp">.</span>
                  </li>)}
              </ul>
              <p className="mt-10 text-2xl font-medium text-beat-red md:text-3xl" data-id="element-69" data-mp="2gjbf3crx8my5">
                Something is happening.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── 04: PEOPLE WITH A BEAT ───────────────────────────── */}
      <section id="people" className="scroll-mt-20 rounded-t-[3rem] bg-white px-5 py-20 text-beat-black md:px-10 md:py-28" data-id="element-70" data-mp="3nygcoadfp8va">
        <div className="mx-auto max-w-[1200px]" data-id="element-71" data-mp="3sv6xfb06osn1">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-72" data-mp="1hu4rjo3lifc">
            <div data-id="element-73" data-mp="39xx8xfg04oyx">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-74" data-mp="39xdsy49wwanj">
                People with a beat
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-75" data-mp="3j0ex3zf7vrok">
                BEAT belongs to people with their own taste.
              </motion.h2>

              <motion.div variants={stagger} className="mt-10 grid gap-8 border-t border-black/10 pt-10" data-id="element-76" data-mp="yah3foytyqi1">
                <PeopleItem title="Create" copy="Ideas that land. Nights that stay sharp all the way to the end." data-id="element-77" data-mp="2eqd44ykkjisz" />
                <PeopleItem title="Connect" copy="Conversations you actually remember. Presence you can feel." data-id="element-78" data-mp="24zs9tnbxh0fv" />
                <PeopleItem title="Move" copy="A body that shows up the next morning, ready to go again." data-id="element-79" data-mp="1zy2zk9wj4qsu" />
              </motion.div>
            </div>

            <motion.div variants={rise} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-80" data-mp="1r1c33we2f9xq">
              <div className="mt-12 md:mt-24" data-id="element-81" data-mp="3le1zqlvtix8t">
                <img src={PEOPLE_IMAGE_1} alt="Candid shot of a woman drinking BEAT at a party" className="aspect-[3/4] w-full object-cover rounded-3xl" data-id="element-82" data-mp="3lcqvym2dhphp" />
              </div>
              <div data-id="element-83" data-mp="2u7wljcs2kwri">
                <img src={PEOPLE_IMAGE_2} alt="Candid shot of a man drinking BEAT with sunglasses" className="aspect-[3/4] w-full object-cover rounded-3xl" data-id="element-84" data-mp="2u8fw28fe4ivi" />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* ── 05: THE WORLD IN MOTION ──────────────────────────── */}
      <Moment src={VIDEO_MOMENT} alt="Bartender grabbing a BEAT can from an ice bowl" label="Club · 23:45" isVideo data-id="element-85" data-mp="2akffzo25be65" />

      {/* ── 06: THE STORY ────────────────────────────────────── */}
      <section id="story" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-86" data-mp="21kaajjgiipum">
        <div className="mx-auto max-w-[1200px]" data-id="element-87" data-mp="3qyyhv6a8xhls">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-88" data-mp="3vx9s3i4gdu4j">
            <div data-id="element-89" data-mp="1tzzl17c4vegz">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-90" data-mp="1u0hrsxwf9b35">
                The Story
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-91" data-mp="22zuzpm4wdrlr">
                São Paulo &rarr; Stockholm &rarr; BEAT.
              </motion.h2>
            </div>
            <div className="flex flex-col justify-center" data-id="element-92" data-mp="2cwrajyi9qpth">
              <motion.p variants={rise} className="text-xl leading-relaxed text-white/70 md:text-2xl" data-id="element-93" data-mp="280sgbua9edl5">
                Someone tasted something amazing. They couldn't stop thinking about it. They brought the idea home. They met the right people. BEAT happened.
              </motion.p>
              <motion.p variants={rise} className="mt-6 text-xl leading-relaxed text-white/70 md:text-2xl" data-id="element-94" data-mp="26oyqwh0yttoy">
                The moment matters more than the beet.
              </motion.p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ── 07: JOIN ─────────────────────────────────────────── */}
      <section id="join" className="scroll-mt-20 px-5 py-20 md:px-10 md:py-28" data-id="element-95" data-mp="1nsywkzkime27">
        <div className="mx-auto max-w-[1200px]" data-id="element-96" data-mp="1iunksjantthc">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-80px'
        }} variants={stagger} className="mb-10 flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-97" data-mp="1xq3lh75qwnmp">
            <div data-id="element-98" data-mp="3478kjskui0si">
              <motion.p variants={rise} className="mb-6 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-99" data-mp="345no1xez07s0">
                Join
              </motion.p>
              <motion.h2 variants={rise} className="text-4xl font-medium tracking-tight md:text-6xl" data-id="element-100" data-mp="3gqmafbu9eu7s">
                Join the BEAT.
              </motion.h2>
            </div>
            <motion.a variants={rise} href={`mailto:${CONTACT_EMAIL}`} className="text-2xl font-medium text-white underline decoration-beat-red decoration-2 underline-offset-8 transition-colors duration-150 hover:text-beat-red md:text-4xl" data-id="element-101" data-mp="36sy73xil8ee0">
              {CONTACT_EMAIL}
            </motion.a>
          </motion.div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-60px'
        }} variants={stagger} className="grid gap-6 lg:grid-cols-3" data-id="element-102" data-mp="3po6eesjib4m3">
            <motion.a variants={rise} href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="group flex flex-col justify-between rounded-3xl bg-white/5 p-8 transition-colors duration-150 hover:bg-beat-red" data-id="element-103" data-mp="vwwf7kzejiba">
              <Instagram size={26} className="mb-12 text-beat-red transition-colors duration-150 group-hover:text-white" data-id="element-104" data-mp="hvsj5les7ma3" />
              <div data-id="element-105" data-mp="cz20cqbleckz">
                <h3 className="text-2xl font-medium" data-id="element-106" data-mp="czllsh0gbj3r">
                  Follow
                </h3>
                <p className="mt-2 flex items-center gap-2 text-base text-white/60 transition-colors duration-150 group-hover:text-white/90" data-id="element-107" data-mp="857jdundgbpl">
                  @beatyourbest_
                  <ArrowUpRight size={18} data-id="element-108" data-mp="3vdl1v6t49omi" />
                </p>
              </div>
            </motion.a>

            <NotifyForm data-id="element-109" data-mp="3qbvrltdpxezh" />
            <StockForm data-id="element-110" data-mp="3ldkbx20qsa9c" />
          </motion.div>
        </div>
      </section>

      {/* ── 08: CLOSING ──────────────────────────────────────── */}
      <section className="bg-beat-red px-5 py-24 md:px-10 md:py-32" data-id="element-111" data-mp="3b8u6una1kq0w">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={stagger} className="mx-auto flex max-w-[1200px] flex-col items-center text-center" data-id="element-112" data-mp="3g874m32gbhi9">
          <motion.h2 variants={rise} className="text-5xl font-medium tracking-tight md:text-7xl" data-id="element-113" data-mp="3q4tn4l7b1wh4">
            Don't waste
            <br data-id="element-114" data-mp="2xjaabz720p01" />
            a heartbeat.
          </motion.h2>
          <motion.img variants={rise} src={SILVER_HEART} alt="" aria-hidden="true" className="-my-8 w-72 mix-blend-multiply md:w-96" data-id="element-115" data-mp="32hlkkb19h1is" />
          <motion.div variants={rise} className="mt-8" data-id="element-116" data-mp="29swdlvdiy1z4">
            <BeatMark className="w-32 md:w-44" data-id="element-117" data-mp="29secakc08xkc" />
          </motion.div>
        </motion.div>
      </section>

      {/* ── FOOTER ───────────────────────────────────────────── */}
      <footer className="px-5 py-12 md:px-10" data-id="element-118" data-mp="kcanq0x16hjf">
        <div className="mx-auto flex max-w-[1200px] flex-col gap-8 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between" data-id="element-119" data-mp="fcfy00ozrxzy">
          <BeatMark className="w-28" data-id="element-120" data-mp="u23zb1x6awno" />
          <div className="flex flex-col gap-4 text-sm text-white/50 md:flex-row md:items-center md:gap-8" data-id="element-121" data-mp="u35b58m0jn6g">
            <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-122" data-mp="p8ss2zog8dv8">
              {CONTACT_EMAIL}
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 hover:text-white" data-id="element-123" data-mp="z2rm1bedcrc3">
              Instagram
            </a>
            <p data-id="element-124" data-mp="3esm97inh3jio">© {new Date().getFullYear()} BEAT Soda</p>
          </div>
        </div>
      </footer>
    </div>;
}
function SiteHeader({
  onNavigate
}: {
  onNavigate: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  const go = (id: string) => {
    setOpen(false);
    window.setTimeout(() => onNavigate(id), 260);
  };
  return <>
      <header className={`fixed inset-x-0 top-0 z-40 transition-colors duration-200 ${scrolled && !open ? 'bg-beat-black/85 backdrop-blur' : 'bg-transparent'}`} style={{
      transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
    }} data-id="element-125" data-mp="wn1wwevtqarv">
        <div className="mx-auto flex max-w-[1200px] items-center justify-between px-5 py-4 md:px-10 md:py-5" data-id="element-126" data-mp="2vxky5sz8ek14">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} aria-label="BEAT Soda — back to top" data-id="element-127" data-mp="2uja5wc5yqkf1">
            <BeatMark className="w-24 md:w-28" data-id="element-128" data-mp="2kj9lemwcxy99" />
          </button>

          <div className="flex items-center gap-3" data-id="element-129" data-mp="2klm08r6tjsi3">
            <button onClick={() => go('join')} className="hidden rounded-full bg-beat-red px-6 py-2.5 text-sm font-medium text-white transition-colors duration-150 hover:bg-white hover:text-beat-black sm:inline-flex" data-id="element-130" data-mp="2gizdv5sx2zsa">
              Join the BEAT
            </button>
            <button onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open} className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-131" data-mp="33h2lzijidw3h">
              <Menu size={20} data-id="element-132" data-mp="1dpley73ejhuo" />
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence data-id="element-133" data-mp="1ioernxav74ts">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: EASE
      }} className="fixed inset-0 z-50 bg-beat-black" data-id="element-134" data-mp="1ip7u4m2sj864">
            <div className="mx-auto flex h-full max-w-[1200px] flex-col px-5 py-4 md:px-10 md:py-5" data-id="element-135" data-mp="21mhcdzwdqfls">
              <div className="flex items-center justify-between" data-id="element-136" data-mp="26dr210hxhixo">
                <BeatMark className="w-24 md:w-28" data-id="element-137" data-mp="2afky0vh6hyri" />
                <button onClick={() => setOpen(false)} aria-label="Close menu" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/25 text-white transition-colors duration-150 hover:border-white hover:bg-white hover:text-beat-black" data-id="element-138" data-mp="2aeb1iapz4ymz">
                  <X size={20} data-id="element-139" data-mp="1qbifcnlo0ito" />
                </button>
              </div>

              <nav className="flex flex-1 flex-col justify-center" data-id="element-140" data-mp="1qdmj95jkdhty">
                <motion.ul initial="hidden" animate="visible" variants={stagger} className="flex flex-col gap-2" data-id="element-141" data-mp="24a048onb41d6">
                  {NAV_LINKS.map(link => <motion.li key={link.id} variants={rise} data-id="element-142" data-mp="17l0pcqs7w1c0">
                      <button onClick={() => go(link.id)} className="text-4xl font-medium tracking-tight text-white/80 transition-colors duration-150 hover:text-beat-red md:text-6xl" data-id="element-143" data-mp="17mvfqkm9clnh">
                        {link.label}
                      </button>
                    </motion.li>)}
                </motion.ul>
              </nav>

              <div className="flex flex-col gap-3 border-t border-white/10 py-6 text-base text-white/50 md:flex-row md:items-center md:justify-between" data-id="element-144" data-mp="osq4sd1fkq2p">
                <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-150 hover:text-white" data-id="element-145" data-mp="jidwa414pj0i">
                  {CONTACT_EMAIL}
                </a>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors duration-150 hover:text-white" data-id="element-146" data-mp="9rsrtzyrxk9o">
                  @beatyourbest_ <ArrowUpRight size={16} data-id="element-147" data-mp="ni4li3b0br2x" />
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function BeatMark({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative flex items-center justify-center ${className}`} data-id="element-148" data-mp="38bhv1isw65bx">
      <img src={LOGO_URL} alt="BEAT Soda" className="w-full h-auto object-contain" data-id="element-149" data-mp="3d9jc5y6rbukr" />
    </div>;
}
function Marquee() {
  const line = 'Good taste — Good people — Good times — ';
  return <div className="overflow-hidden bg-beat-red py-5" data-id="element-150" data-mp="2evfdcjdfxq19">
      <motion.div animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 22,
      ease: 'linear',
      repeat: Infinity
    }} className="flex w-max whitespace-nowrap" data-id="element-151" data-mp="2jtyzokvy53u5">
        {[0, 1].map(group => <span key={group} className="text-lg font-medium uppercase tracking-widest text-white md:text-xl" data-id="element-152" data-mp="1w2bg6o10kv1w">
            {line.repeat(6)}
          </span>)}
      </motion.div>
    </div>;
}
function Moment({
  src,
  alt,
  label,
  isVideo = false
}: {
  src: string;
  alt: string;
  label: string;
  isVideo?: boolean;
}) {
  return <section className="relative h-[80vh] w-full overflow-hidden md:h-screen" data-id="element-153" data-mp="1dcbvedc7i24a">
      {isVideo ? <motion.video src={src} autoPlay loop muted playsInline initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-154" data-mp="15ssrqkbmha3q" /> : <motion.img src={src} alt={alt} initial={{
      opacity: 0,
      scale: 1.04
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-10%'
    }} transition={{
      duration: 1.1,
      ease: EASE
    }} className="h-full w-full object-cover" data-id="element-155" data-mp="i2gmjh7rhrgu" />}
      <p className="absolute bottom-6 left-5 text-sm font-medium tracking-widest text-white/80 uppercase md:left-10" data-id="element-156" data-mp="3kp6a4q9ur0pu">
        {label}
      </p>
    </section>;
}
function PeopleItem({
  title,
  copy
}: {
  title: string;
  copy: string;
}) {
  return <motion.div variants={rise} data-id="element-157" data-mp="3bpsyps26422h">
      <h3 className="text-3xl font-medium md:text-4xl" data-id="element-158" data-mp="3bqkvv7bey7uv">
        {title}
        <span className="text-beat-red" data-id="element-159" data-mp="3gnl1jh4cp8lg">.</span>
      </h3>
      <p className="mt-4 max-w-xs text-lg leading-relaxed text-black/60" data-id="element-160" data-mp="86zrdwzzg9gr">
        {copy}
      </p>
    </motion.div>;
}
async function sendToBeat(payload: Record<string, string>) {
  const response = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      access_key: WEB3FORMS_KEY,
      from_name: 'BEAT Website',
      to: CONTACT_EMAIL,
      ...payload
    })
  });
  return response.ok;
}
function NotifyForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new launch signup',
      email,
      message: `New launch signup.\n\nEmail: ${email}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setEmail('');
  };
  return <motion.div variants={rise} className="flex flex-col justify-between rounded-3xl bg-white/5 p-8" data-id="element-161" data-mp="mf4dn5qcyg48">
      <p className="mb-16 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-162" data-mp="waxwf6uo75ug">
        Launch
      </p>
      <div data-id="element-163" data-mp="rbl96kzvzwrc">
        <h3 className="text-2xl font-medium" data-id="element-164" data-mp="rbuz68kxm3x1">
          Be first
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-base font-medium text-beat-red" data-id="element-165" data-mp="27p32c5eg1psf">
            <Check size={18} data-id="element-166" data-mp="22q8c4ie5cyya" /> You're on the list
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-4" data-id="element-167" data-mp="capi810ugjba">
            <input type="email" required value={email} onChange={event => setEmail(event.target.value)} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-168" data-mp="h998ueqduj9z" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-base font-medium text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-169" data-mp="106twjihevbt0">
              {status === 'loading' ? 'Sending…' : 'Notify me →'}
            </button>
            {status === 'error' && <p className="text-sm text-white/50" data-id="element-170" data-mp="1iy34hnbj9sih">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}
function StockForm() {
  const [form, setForm] = useState({
    company: '',
    email: '',
    notes: ''
  });
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!form.company || !form.email) return;
    setStatus('loading');
    const ok = await sendToBeat({
      subject: 'BEAT — new stockist enquiry',
      email: form.email,
      company: form.company,
      notes: form.notes || 'No notes',
      message: `New stockist enquiry.\n\nCompany: ${form.company}\nEmail: ${form.email}\nNotes: ${form.notes || 'No notes'}`
    }).catch(() => false);
    setStatus(ok ? 'success' : 'error');
    if (ok) setForm({
      company: '',
      email: '',
      notes: ''
    });
  };
  return <motion.div variants={rise} className="flex flex-col justify-between rounded-3xl bg-white/5 p-8" data-id="element-171" data-mp="4xgkpl7gdjej">
      <p className="mb-16 text-sm font-medium tracking-widest text-beat-red uppercase" data-id="element-172" data-mp="nxczha0jo5us">
        Trade
      </p>
      <div data-id="element-173" data-mp="sw7fk474ngb7">
        <h3 className="text-2xl font-medium" data-id="element-174" data-mp="f2yecqtc213r">
          Stock BEAT
        </h3>
        {status === 'success' ? <p className="mt-4 flex items-center gap-2 text-base font-medium text-beat-red" data-id="element-175" data-mp="j41nyvksf0wj">
            <Check size={18} data-id="element-176" data-mp="5524e2c4tc78" /> We'll be in touch
          </p> : <form onSubmit={handleSubmit} className="mt-4 flex flex-col gap-4" data-id="element-177" data-mp="5751157si3kx">
            <input type="text" required value={form.company} onChange={event => setForm({
          ...form,
          company: event.target.value
        })} placeholder="Venue or company" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-178" data-mp="a56kvsd1i6xg" />
            <input type="email" required value={form.email} onChange={event => setForm({
          ...form,
          email: event.target.value
        })} placeholder="Your email" disabled={status === 'loading'} className="w-full border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-179" data-mp="3b178istkgn9b" />
            <textarea rows={2} value={form.notes} onChange={event => setForm({
          ...form,
          notes: event.target.value
        })} placeholder="Volumes, timing, anything else" disabled={status === 'loading'} className="w-full resize-none border-b border-white/25 bg-transparent pb-3 text-base text-white placeholder:text-white/40 focus:border-beat-red focus:outline-none disabled:opacity-50" data-id="element-180" data-mp="bioekvhi6nch" />
            <button type="submit" disabled={status === 'loading'} className="self-start text-base font-medium text-white transition-colors duration-150 hover:text-beat-red disabled:opacity-50" data-id="element-181" data-mp="1wahy3ze5x8mf">
              {status === 'loading' ? 'Sending…' : 'Send enquiry →'}
            </button>
            {status === 'error' && <p className="text-sm text-white/50" data-id="element-182" data-mp="1difcsaqkt45u">
                Didn't go through — try again.
              </p>}
          </form>}
      </div>
    </motion.div>;
}